import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AstronomerHideout3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASTRONOMER_HIDEOUT3;
}

export default AstronomerHideout3PoiTileEntity;
